import React, { useState, useEffect } from "react";
import { Button, TextField, Chip } from "@mui/material";
import Abhaicons from "../../Images/Adharicon.svg";
import Abhashiled from "../../Images/material-symbols-light_shield-outline.svg";

const Step3AbhaAddressSuggestions = ({
  abhaSuggestions,
  selectedAbhaAddress,
  setSelectedAbhaAddress,
  onFetchSuggestions,
  onSubmit,
  onBack,
}) => {
  const [inputError, setInputError] = useState("");
  const [showInput, setShowInput] = useState(false);

  // Fetch suggestions when component mounts
  useEffect(() => {
    if (!showInput && abhaSuggestions.length === 0) {
      onFetchSuggestions();
    }
  }, []);

  // Show input after suggestions are loaded
  useEffect(() => {
    if (abhaSuggestions.length > 0) {
      setShowInput(true);
    }
  }, [abhaSuggestions]);

  // Validate ABHA Address
  const validateAbhaAddress = (value) => {
    if (!value) {
      return "ABHA Address is required";
    }

    if (value.length < 8) {
      return "ABHA Address must be at least 8 characters";
    }

    // Check if starts or ends with . or _
    if (value.startsWith(".") || value.startsWith("_") || value.endsWith(".") || value.endsWith("_")) {
      return "ABHA Address cannot start or end with '.' or '_'";
    }

    // Check if contains only allowed characters (alphanumeric, . and _)
    const validPattern = /^[a-zA-Z0-9._]+$/;
    if (!validPattern.test(value)) {
      return "ABHA Address can only contain letters, numbers, '.' and '_'";
    }

    return "";
  };

  // Handle ABHA Address Change
  const handleAbhaAddressChange = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s/g, ""); // Convert to lowercase and remove spaces
    setSelectedAbhaAddress(value);

    // Validate on change
    const error = validateAbhaAddress(value);
    setInputError(error);
  };

  // Handle Suggestion Click
  const handleSuggestionClick = (suggestion) => {
    setSelectedAbhaAddress(suggestion);
    setInputError("");
  };

  // Check if submit is valid
  const isSubmitValid = selectedAbhaAddress.length >= 8 && !inputError;

  // Get top 3 suggestions
  const topSuggestions = abhaSuggestions.slice(0, 3);

  return (
    <div className="text-center">
      <img src={Abhaicons} alt="ABHA Icon" />
      <h5 className="sub-text">ABHA Address Suggestions</h5>
      <p className="sub-para">
        Create Your Unique ABHA Address
      </p>

      {/* Informational Text */}
      <div className="abha-desc mt-3 mb-4">
        <p style={{ textAlign: "left", fontSize: "13px", marginBottom: "8px" }}>
          ABHA (Ayushman Bharat Health Account) address is a unique username that allows you to share and access your health records digitally. It is similar to an email address, but it is only used for health records.
        </p>
        <p style={{ textAlign: "left", fontSize: "13px", marginBottom: "8px" }}>
          To create ABHA address, it should have Min - 8 characters, Max - 18 characters, special characters allowed - 1 dot (.) and/or 1 underscore (_).
        </p>
        <p style={{ textAlign: "left", fontSize: "13px", marginBottom: "0" }}>
          Choose from suggested addresses below or create your own custom ABHA Address.
        </p>
      </div>

      {showInput && (
        <>
          {/* Show top 3 suggestions */}
          {topSuggestions.length > 0 && (
            <div className="mt-3 mb-3">
              <p className="text-start" style={{ fontSize: "14px", fontWeight: "500", marginBottom: "8px" }}>
                Suggested Addresses:
              </p>
              <div className="d-flex flex-wrap gap-2">
                {topSuggestions.map((suggestion, index) => (
                  <Chip
                    key={index}
                    label={`${suggestion}@sbx`}
                    onClick={() => handleSuggestionClick(suggestion)}
                    variant={selectedAbhaAddress === suggestion ? "filled" : "outlined"}
                    color={selectedAbhaAddress === suggestion ? "primary" : "default"}
                    sx={{ cursor: "pointer" }}
                  />
                ))}
              </div>
            </div>
          )}

          {/* ABHA Address Input */}
          <div className="mt-3">
            <TextField
              label="Enter ABHA Address"
              variant="outlined"
              fullWidth
              size="medium"
              value={selectedAbhaAddress}
              onChange={handleAbhaAddressChange}
              placeholder="youraddress"
              InputProps={{
                endAdornment: <span style={{ color: "#666", fontWeight: "500" }}>@sbx</span>,
              }}
              error={Boolean(inputError)}
              helperText={inputError}
            />
          </div>

          {/* Display full address preview */}
          {selectedAbhaAddress && !inputError && (
            <div className="mt-3 p-2" style={{ backgroundColor: "#f0f7ff", borderRadius: "8px" }}>
              <p style={{ fontSize: "14px", color: "#155DFC", fontWeight: "500", margin: 0 }}>
                Your ABHA Address: <strong>{selectedAbhaAddress}@sbx</strong>
              </p>
            </div>
          )}

          {/* Submit Button */}
          <Button
            className={`send-otp-btn ${isSubmitValid ? "active" : ""}`}
            variant="contained"
            fullWidth
            disabled={!isSubmitValid}
            onClick={onSubmit}
            sx={{ mt: 3 }}
          >
            Confirm ABHA Address
          </Button>
        </>
      )}

      <div className="para-ofadhar">
        <span>
          <img src={Abhashiled} alt="Shield" />
        </span>
        <p>
          Your ABHA Address will be unique and permanent. Choose carefully.
        </p>
      </div>
    </div>
  );
};

export default Step3AbhaAddressSuggestions;